import {
  initializeFirebase,
  FirebaseAuth,
  FirebaseDatabase,
  FirestoreDatabase,
} from 'refine-firebase';
// import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';

export const livenowFirebaseConfig = {
  apiKey: 'AIzaSyCAwDikHmndGq7L_hC9EiKJlt38QPAwaZY',
  authDomain: 'live-now-5a061.firebaseapp.com',
  databaseURL: 'https://live-now-5a061.firebaseio.com',
  projectId: 'live-now-5a061',
  storageBucket: 'live-now-5a061.appspot.com',
  messagingSenderId: '581378927490',
  appId: '1:581378927490:web:1f97195563b8dc1ade7d9b',
  measurementId: 'G-GXSZ3MEHYR',
};

const appName = 'livenow';
export const firebaseApp = initializeFirebase(
  livenowFirebaseConfig,
  appName
);

export const firebaseAuth = new FirebaseAuth(undefined, firebaseApp);

export const firestoreDatabase = new FirestoreDatabase({
  firebaseApp,
});

export const firebaseDatabase = new FirebaseDatabase({
  firebaseApp,
});

export const firebaseAppDefault = initializeApp(
  livenowFirebaseConfig,
  appName
);
export const firebaseAuthDefault = getAuth(firebaseAppDefault);
// export const storage = getStorage(firebaseAppDefault);
